import {Avatar, Button, DatePicker, Input, Radio} from 'antd'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {Formik} from 'formik'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, {useMemo, useState} from 'react'
import {compose, mapProps, withProps} from 'recompose'
import {GenderTypes} from 'views/AppLocals/appFieldTypes'
import {appClassNames} from 'views/AppLocals/custom/appClassNames'
import {ErrorSummaries} from 'views/AppLocals/factory/createEditableForm'
import {createControlledFormField} from 'views/AppLocals/factory/createFormField'
import {NullAsDefault, shallowDiff} from 'views/Shared'
import AvatarUploader from '../../../Workspace/components/AvatarUploader'
import {BsHash, BsImage, BsPersonCircle} from 'react-icons/bs'
import {NameInputField} from '../../../../components/form/fields/NameInputField'
import {gConfigs} from '../../configs'
import {IoCalendarOutline} from 'react-icons/io5'
import {createValue} from '../../../../components/form/utils'
import {getDateString, parseDayjs} from '../../../../helpers/datetimeHelpers'
import {LookupTagsPicker} from '../../custom/TagsPicker'
import {IdentifierTypes} from '../../appFieldTypes'
import IdentifierCodeLookupField from '../../../../components/IdentifierCodeLookupField'
import {API_ROOT_URL} from '../../../../envs/_current/config'
import {baseItemSchema} from '../../../../apis/schema'
import {createListTransform} from '../../../../apis/utils/createListTransform'
import Pure from '../../../../components/Pure'
import useToggle from 'react-use/lib/useToggle'
import {renderIf} from '../../../Shared'
import ForDevelop from '../../../../envs/ForDevelop'
import UserLookupComponent from '../../../../components/UserLookupComponent'
import {RiSearch2Line} from 'react-icons/ri'
import dayjs from 'dayjs'
import {ActionModalWrapper} from '../../../../components/form/ActionModalWrapper'
import LookupField from '../../../../components/LookupField'
import {SaintsOutlineSvg} from '../../../../components/Svgs/SaintsPlaceholder'
import {FaGraduationCap, FaPhone, FaUserTie} from 'react-icons/fa6'
import {
  digitLength,
  eachWordUppercase,
  emailFormat,
  firstLetterUppercase,
  lengthBetween,
  noDoubleSpaces,
  noLeadingTrailingSpaces,
  noSpecialChars,
  passportFormart,
  required,
} from '../../../../components/form/ValidateForm'

export const formSchema = {
  contact_email__phone: {
    inline: true,
    className: appClassNames.inline_2,
    children: [
      {
        label: 'email',
        name: 'contact_email',
        component: createControlledFormField({
          type: 'email',
          placeholder: 'ex: email',
          autoComplete: false,
          Component: Input,
        }),
      },
      {
        label: 'phone',
        name: 'contact_phone',
        component: createControlledFormField({
          type: 'tel',
          placeholder: 'ex: phone',
          autoComplete: false,
          Component: Input,
        }),
      },
    ],
  },

  contact_email: {
    title: 'email',
    children: [
      {
        name: 'contact_email',
        component: createControlledFormField({
          type: 'email',
          placeholder: 'ex: email',
          Component: Input,
        }),
      },
    ],
  },
  contact_phone: {
    title: 'phone',
    children: [
      {
        name: 'contact_phone',
        component: createControlledFormField({
          type: 'tel',
          placeholder: 'ex: phone',
          Component: Input,
        }),
      },
    ],
  },

  contact_address: {
    title: 'address',
    children: [
      {
        name: 'contact_address',
        component: createControlledFormField({
          showCount: true,
          maxLength: 500,
          placeholder: 'ex: address',
          Component: Input,
        }),
      },
    ],
  },

  id_validator: {
    inline: true,
    className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
    // itemClassNames: ['col-span-1', 'col-span-1 md:col-span-2'],
    children: [
      {
        label: 'identifier code',
        name: 'identifier_code',
        className: 'flex-1',
        component: compose(
          withTranslate,
          mapProps(({ name, value, form, translate, onChange }) => ({
            name,
            onChange,
            type: 'id code',
            placeholder: translate('ex: id code'),
            defaultValue: value,
            params: {
              ...{
                owner_type: form?.values?.owner_type,
                owner_id: form?.values?.owner_id,
              },
              search_type: 'user',
              input_type: 'identifier_code',
            },
            handleApply: (info) => {
              const { values, setValues } = form ?? {}
              const { identifier_type, identifier_code } = info ?? {}
              const user_info = _.omitBy(
                {
                  identifier_type: _.find(IdentifierTypes, {
                    value: identifier_type,
                  })?.value,
                  identifier_code: !!String(identifier_code ?? '').length
                    ? identifier_code
                    : undefined,
                  user: info,
                  user_id: info?.id,
                },
                _.isUndefined
              )
              setValues({
                ...values,
                ...(user_info ?? {}),
              })
            },
          }))
        )(IdentifierCodeLookupField),
      },
      {
        label: 'identifier type',
        name: 'identifier_type',
        component: compose(
          withTranslate,
          mapProps(({ name, value, onChange, translate }) => ({
            name,
            value,
            onChange,
            buttonStyle: 'solid',
            className: 'w-full custom-radio-button whitespace-no-wrap',
            children: Object.values(IdentifierTypes).map(
              ({ name, value, label }) => (
                <Radio.Button
                  style={{ padding: '0px 10px' }}
                  key={name}
                  value={value}>
                  {translate(label)}
                </Radio.Button>
              )
            ),
          }))
        )(Radio.Group),
      },
    ],
  },

  patron_saint__fullname: {
    inline: true,
    className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
    itemClassNames: ['col-span-1', 'col-span-1 md:col-span-2'],
    children: [
      {
        label: 'holy name',
        name: 'patron_saint',
        component: ({ name, value, onChange, form }) => (
          <Translate>
            {(t) => (
              <LookupField
                title={t('choose patron saint')}
                createIfNotExists={true}
                defaultValue={form?.values?.patron_saint_name}
                selectedOption={form?.values?.patron_saint}
                apiPath={`/lookup/saint/get-by-types`}
                name={name}
                OptionWrapper={({ children, ...props }) => (
                  <div
                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative"
                    {...props}>
                    {children}
                  </div>
                )}
                renderOption={(o, i) => {
                  return (
                    <div
                      key={i}
                      className="flex items-center flex-1 gap-3">
                      <Avatar
                        size={50}
                        src={o.avatar}
                        className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                        icon={
                          <SaintsOutlineSvg
                            size={30}
                            style={{ color: '#dddddd' }}
                          />
                        }
                      />
                      <div className="flex flex-col flex-1">
                        <span className="font-bold text-sm text-color-000 leading-snug">
                          {`${o.common_name || o.name} (${
                            o.patron_saint_feast_day || o.feast_day
                          })`}
                        </span>
                        {renderIf(
                          o?.description,
                          <span className="text-xs text-color-400 italic max-lines-1">
                            {o?.description}
                          </span>
                        )}
                      </div>
                    </div>
                  )
                }}
                handleChange={(e) => {
                  form.setValues({
                    ...form.values,
                    patron_saint: e.target,
                    patron_saint_name: e.target.common_name || e.target.value,
                    patron_saint_feast_day: e.target.feast_day,
                    patron_saint_id: e.target.id,
                  })
                }}
              />
            )}
          </Translate>
        ),
      },
      {
        label: 'fullname',
        name: 'fullname',
        required: true,
        component: ({ name, value, form, onChange }) => (
          <Translate>
            {(t) => (
              <div className="flex flex-col gap-1">
                <Input.Group
                  compact
                  style={{ display: 'inline-flex', alignItems: 'center' }}
                  className="custom-input-group">
                  <Input
                    name={name}
                    value={value}
                    onChange={onChange}
                    allowClear={true}
                    placeholder={t('Enter your name')}
                    style={{ borderRadius: '0.375rem 0 0 0.375rem' }}
                    className="flex-1"
                  />
                  <UserLookupComponent
                    handleApply={(userInfo) => {
                      const { values, setValues } = form ?? {}
                      const {
                        name,
                        email,
                        gender,
                        phone_number,
                        identifier_type,
                        identifier_code,
                        date_of_birth,
                        place_of_birth,
                        address,
                        patron_saint,
                        patron_saint_name,
                        parish,
                        parish_name,
                        diocese,
                        diocese_name,
                        religious_order,
                      } = userInfo ?? {}

                      const user_info = _.omitBy(
                        {
                          email,
                          gender: _.find(GenderTypes, { value: gender })?.value,
                          date_of_birth: !!String(date_of_birth ?? '').length
                            ? parseDayjs(date_of_birth)
                            : undefined,
                          place_of_birth: place_of_birth ?? undefined,
                          fullname: !!String(name ?? '').length
                            ? name
                            : undefined,
                          contact_phone: phone_number
                            ? phone_number
                            : undefined,
                          contact_email: email ?? undefined,
                          contact_address: address ?? undefined,

                          identifier_type: _.find(IdentifierTypes, {
                            value: identifier_type,
                          })?.value,
                          identifier_code: !!String(identifier_code ?? '')
                            .length
                            ? identifier_code
                            : undefined,

                          user: userInfo,
                          user_id: userInfo?.id,

                          patron_saint: patron_saint,
                          patron_saint_id: patron_saint?.id,
                          patron_saint_name: patron_saint_name,

                          diocese_id: diocese?.id,
                          diocese_name: diocese_name,
                          diocese: diocese,

                          parish_id: parish?.id,
                          parish_name: parish_name,
                          parish: parish,

                          religious_order: religious_order,
                          religious_order_id: religious_order?.id,
                          religious_order_name: userInfo?.religious_order_name,
                        },
                        _.isUndefined
                      )
                      setValues({
                        ...values,
                        ...(user_info ?? {}),
                        refreshKey: Date.now(),
                      })
                    }}>
                    <Button
                      type="primary"
                      style={{ width: 46, border: '1px solid transparent' }}
                      icon={
                        <RiSearch2Line
                          size={14}
                          className="hover:opacity-85 cursor-pointer"
                        />
                      }
                      className="flex flex-center"
                    />
                  </UserLookupComponent>
                </Input.Group>
                <span className="text-xs text-color-500 italic leading-tight">
                  {`* `}
                  {t(
                    'click on {n} to, lookup user accounts on the {m} platform',
                    {
                      n: (
                        <RiSearch2Line
                          size={13}
                          className="mx-1 text-color-000"
                        />
                      ),
                      m: (
                        <span className="font-bold text-blue-600 tracking-widest">
                          {'Kristo Network'}
                        </span>
                      ),
                    }
                  )}
                </span>
              </div>
            )}
          </Translate>
        ),
      },
    ],
  },

  name_gender: {
    inline: true,
    className: 'flex gap-3',
    itemClassNames: ['flex-1', ''],
    children: [
      {
        label: 'fullname',
        name: 'fullname',
        component: ({ name, form, value, onChange }) => {
          const { prefix_title } = form?.values ?? {}
          return (
            <Translate>
              {(t) => (
                <Input.Group
                  style={{ display: 'inline-flex', alignItems: 'center' }}>
                  <NameInputField
                    placeholder={t('fullname')}
                    {...{ name, value, onChange }}
                    prefix={
                      <Input
                        onChange={onChange}
                        name="prefix_title"
                        value={prefix_title}
                        style={{
                          maxWidth: 150,
                          borderRightWidth: 1,
                          marginRight: -1,
                        }}
                        placeholder={t('prefix example')}
                      />
                    }
                  />
                  <UserLookupComponent
                    handleApply={(userInfo) => {
                      const { values, setValues } = form ?? {}
                      const {
                        name,
                        email,
                        gender,
                        phone_number,
                        identifier_type,
                        identifier_code,
                        date_of_birth,
                        patron_saint,
                        religious_order,
                      } = userInfo ?? {}
                      const user_info = _.omitBy(
                        {
                          email,
                          contact_email: email ?? undefined,
                          gender: _.find(GenderTypes, { value: gender })?.value,
                          identifier_type: _.find(IdentifierTypes, {
                            value: identifier_type,
                          })?.value,
                          identifier_code: !!String(identifier_code ?? '')
                            .length
                            ? identifier_code
                            : undefined,
                          date_of_birth: !!String(date_of_birth ?? '').length
                            ? parseDayjs(date_of_birth)
                            : undefined,
                          fullname: !!String(name ?? '').length
                            ? name
                            : undefined,
                          contact_phone: phone_number ?? undefined,
                          user: userInfo,
                          user_id: userInfo?.id,
                        },
                        _.isUndefined
                      )
                      setValues({
                        ...values,
                        ...(user_info ?? {}),
                      })
                    }}>
                    <Button
                      type="primary"
                      style={{
                        width: 46,
                        padding: '0 15px',
                        border: '1px solid transparent',
                        borderRadius: '0 0.375rem 0.375rem 0',
                      }}
                      icon={
                        <RiSearch2Line
                          size={14}
                          className="hover:opacity-85 cursor-pointer"
                        />
                      }
                      className="flex flex-center"
                    />
                  </UserLookupComponent>
                </Input.Group>
              )}
            </Translate>
          )
        },
      },
      {
        label: 'gender',
        name: 'gender',
        component: compose(
          withProps({
            buttonStyle: 'solid',
            className: 'w-full custom-radio-button whitespace-no-wrap',
            name: 'gender',
            children: Object.values(GenderTypes).map(
              ({ name, value, label }) => (
                <Translate key={name}>
                  {(t) => (
                    <Radio.Button
                      style={{ padding: '0px 10px' }}
                      value={value}>
                      {t(label)}
                    </Radio.Button>
                  )}
                </Translate>
              )
            ),
          })
        )(Radio.Group),
      },
    ],
  },
  phone_gender: {
    inline: true,
    className: appClassNames.inline_2,
    children: [
      {
        label: 'phone',
        name: 'contact_phone',
        component: createControlledFormField({
          type: 'tel',
          placeholder: 'ex: phone',
          Component: Input,
        }),
      },
      {
        label: 'gender',
        name: 'gender',
        component: compose(
          withProps({
            name: 'gender',
            buttonStyle: 'solid',
            className: 'w-full custom-radio-button',
            children: Object.values(GenderTypes).map(
              ({ name, value, label }) => (
                <Translate key={name}>
                  {(t) => (
                    <Radio.Button
                      style={{ padding: '0px 10px' }}
                      value={value}>
                      {t(label)}
                    </Radio.Button>
                  )}
                </Translate>
              )
            ),
          })
        )(Radio.Group),
      },
    ],
  },
  fullname: {
    title: 'fullname',
    children: [
      {
        name: 'fullname',
        component: ({ name, form, value, onChange }) => {
          const { prefix_title } = form?.values ?? {}
          return (
            <Translate>
              {(t) => (
                <Input.Group
                  style={{ display: 'inline-flex', alignItems: 'center' }}>
                  <NameInputField
                    placeholder={t('fullname')}
                    {...{ name, value, onChange }}
                    prefix={
                      <Input
                        onChange={onChange}
                        name="prefix_title"
                        value={prefix_title}
                        style={{
                          maxWidth: 150,
                          borderRightWidth: 1,
                          marginRight: -1,
                        }}
                        placeholder={t('prefix example')}
                      />
                    }
                  />
                  <UserLookupComponent
                    handleApply={(userInfo) => {
                      const { values, setValues } = form ?? {}
                      const {
                        name,
                        email,
                        gender,
                        phone_number,
                        identifier_type,
                        identifier_code,
                        date_of_birth,
                      } = userInfo ?? {}
                      const user_info = _.omitBy(
                        {
                          email,
                          contact_email: email ?? undefined,
                          gender: _.find(GenderTypes, { value: gender })?.value,
                          identifier_type: _.find(IdentifierTypes, {
                            value: identifier_type,
                          })?.value,
                          identifier_code: !!String(identifier_code ?? '')
                            .length
                            ? identifier_code
                            : undefined,
                          date_of_birth: !!String(date_of_birth ?? '').length
                            ? parseDayjs(date_of_birth)
                            : undefined,
                          fullname: !!String(name ?? '').length
                            ? name
                            : undefined,
                          contact_phone: phone_number ?? undefined,
                          user: userInfo,
                          user_id: userInfo?.id,
                        },
                        _.isUndefined
                      )
                      setValues({
                        ...values,
                        ...(user_info ?? {}),
                      })
                    }}>
                    <Button
                      type="primary"
                      style={{
                        width: 46,
                        padding: '0 15px',
                        border: '1px solid transparent',
                        borderRadius: '0 0.375rem 0.375rem 0',
                      }}
                      icon={
                        <RiSearch2Line
                          size={14}
                          className="hover:opacity-85 cursor-pointer"
                        />
                      }
                      className="flex flex-center"
                    />
                  </UserLookupComponent>
                </Input.Group>
              )}
            </Translate>
          )
        },
      },
    ],
  },
  gender: {
    title: 'gender',
    children: [
      {
        name: 'gender',
        component: compose(
          withProps({
            name: 'gender',
            buttonStyle: 'solid',
            className: 'w-full custom-radio-button',
            children: Object.values(GenderTypes).map(
              ({ name, value, label }) => (
                <Translate key={name}>
                  {(t) => (
                    <Radio.Button
                      style={{ padding: '0px 10px' }}
                      value={value}>
                      {t(label)}
                    </Radio.Button>
                  )}
                </Translate>
              )
            ),
          })
        )(Radio.Group),
      },
    ],
  },
  date__place_of_birth: {
    inline: true,
    className: appClassNames.inline_2,
    children: [
      {
        label: 'date of birth',
        name: 'date_of_birth',
        component: compose(
          withTranslate,
          mapProps(({ name, value, onChange, translate }) => ({
            name,
            value,
            className: 'w-full',
            format: gConfigs.dateFormat,
            suffixIcon: <IoCalendarOutline className="text-color-500" />,
            placeholder: `${translate('date of birth')} "DD/MM/YYYY"`,
            // 🔹 Giới hạn ngày
            disabledDate: (current) => {
              const maxDate = dayjs().subtract(10, 'year')
              const minDate = dayjs().subtract(120, 'year')

              return (
                current &&
                (current > maxDate.endOf('day') ||
                  current < minDate.startOf('day'))
              )
            },
            // 🔹 mở lịch ở khoảng năm hợp lý
            defaultPickerValue: value ?? dayjs().subtract(30, 'year'),
            onChange: (date, dateString) => {
              onChange(createValue(name, date ? dayjs(new Date(date)) : null))
            },
          }))
        )(DatePicker),
      },
      {
        label: 'place of birth',
        name: 'place_of_birth',
        component: createControlledFormField({
          placeholder: 'place of birth',
          Component: Input,
        }),
      },
    ],
  },

  majors: {
    title: 'majors',
    children: [
      {
        name: 'majors',
        component: createControlledFormField({
          autoSize: { minRows: 3, maxRows: 5 },
          placeholder: 'ex: majors',
          showCount: true,
          maxLength: 1000,
          Component: Input.TextArea,
        }),
      },
    ],
  },
  fields: {
    title: 'fields',
    children: [
      {
        name: 'fields',
        component: createControlledFormField({
          autoSize: { minRows: 3, maxRows: 5 },
          placeholder: 'ex: fields',
          showCount: true,
          maxLength: 1000,
          Component: Input.TextArea,
        }),
      },
    ],
  },
  experiences: {
    title: 'experiences',
    children: [
      {
        name: 'experiences',
        component: createControlledFormField({
          autoSize: { minRows: 3, maxRows: 5 },
          placeholder: 'ex: experiences',
          showCount: true,
          maxLength: 1000,
          Component: Input.TextArea,
        }),
      },
    ],
  },
  degrees: {
    title: 'degrees',
    children: [
      {
        name: 'degrees',
        component: createControlledFormField({
          autoSize: { minRows: 3, maxRows: 5 },
          placeholder: 'ex: degrees',
          showCount: true,
          maxLength: 1000,
          Component: Input.TextArea,
        }),
      },
    ],
  },

  avatar: {
    title: 'avatar',
    children: [
      {
        name: 'avatar',
        component: createControlledFormField({
          withValues: ({ avatar_preview }) => ({
            value: avatar_preview,
            width: 150,
            height: 150,
            icon: (
              <BsImage
                size={70}
                style={{ color: '#eaeaea' }}
              />
            ),
          }),
          Component: AvatarUploader,
        }),
      },
    ],
  },
  hashtags: {
    title: 'category tags',
    children: [
      {
        name: 'hashtags',
        component: createControlledFormField({
          className: 'w-full',
          Component: LookupTagsPicker,
          placeholder: 'tags',
          apiInfo: {
            root: API_ROOT_URL,
            path: '/lookup/teacher_hashtags/gets',
            method: 'GET',
            schema: baseItemSchema,
            transform: createListTransform(baseItemSchema),
            paramFields: ['keyword'],
            fields: ['keyword'],
          },
          withProps: ({ name, onChange }) => ({
            onChange: (e, option) => {
              onChange(createValue(name, e.target.value))
            },
          }),
        }),
      },
    ],
  },
}

const runRules = (value, rules) => {
  for (const rule of rules) {
    const error = rule(value)
    if (error) return error
  }
  return null
}

function validateName(name, requireField, keyName, t) {
  const error = {}
  const maxLengthConfig = {
    fullname: 120,
    patron_saint: 180,
    father_name: 255,
    mother_name: 255,
  }
  if (!name && !requireField) return error
  const maxLength = maxLengthConfig[keyName]
  const rules = [
    requireField ? required(t) : null,
    lengthBetween(2, maxLength, t),
    noSpecialChars(t),
    noLeadingTrailingSpaces(t),
    noDoubleSpaces(t),
    firstLetterUppercase(t),
    eachWordUppercase(t),
  ].filter(Boolean)
  const message = runRules(name, rules)
  if (message) {
    error[keyName] = message
  }
  return error
}

const validateEmail = (email, t) => {
  if (!email) return {}
  const rules = [lengthBetween(5, 120, t), emailFormat(t)]
  const error = runRules(email, rules)
  return error ? { contact_email: error } : {}
}

const validatePhoneNumber = (phone, t) => {
  if (!phone) return {}
  const rules = [digitLength(10, 16, t)]
  const error = runRules(phone, rules)
  return error ? { contact_phone: error } : {}
}

const validateAddress = (address, t) => {
  if (!address) return {}
  const rules = [
    lengthBetween(5, 500, t),
    noLeadingTrailingSpaces(t),
    noDoubleSpaces(t),
  ]
  const error = runRules(address, rules)
  return error ? { contact_address: error } : {}
}

const validateCategoryTags = (categoryTags, t) => {
  if (!Array.isArray(categoryTags) || categoryTags.length === 0) return {}
  const rules = [
    lengthBetween(2, 255, t),
    noSpecialChars(t),
    noLeadingTrailingSpaces(t),
    noDoubleSpaces(t),
  ]
  for (const tag of categoryTags) {
    const message = runRules(tag, rules)
    if (message) {
      return { hashtags: message }
    }
  }
}

const validateMajorsOrFieldsOrExperiencesOrDegrees = (value, keyName, t) => {
  const error = {}
  if (!value) return {}
  const rules = [
    lengthBetween(1, 1000, t),
    noLeadingTrailingSpaces(t),
    noDoubleSpaces(t),
  ]
  const message = runRules(value, rules)
  if (message) {
    error[keyName] = message
  }
  return error
}

const validateIdentityOrDriverLisenceOrPassport = (value, type, t) => {
  if (!value) return { identifier_code: t('required') }
  const rules =
    type === 'identitycard' || type === 'driverlicense'
      ? [digitLength(12, 50, t)]
      : [passportFormart(t)]
  const error = runRules(value, rules)
  return error ? { identifier_code: error } : {}
}

const validateCreateAndEditTeacher = (t) => (values) => {
  const {
    patron_saint,
    fullname,
    identifier_type,
    identifier_code,
    contact_email,
    contact_phone,
    contact_address,
    majors,
    fields,
    experiences,
    degrees,
    hashtags
  } = values ?? {}
  const errorPatronSaint = validateName(
    patron_saint ? patron_saint.value : '',
    false,
    'patron_saint',
    t
  )
  const errorFullname = validateName(fullname, true, 'fullname', t)
  const errorIdentity = validateIdentityOrDriverLisenceOrPassport(
    identifier_code,
    identifier_type,
    t
  )
  const errorEmail = validateEmail(contact_email, t)
  const errorPhoneNumber = validatePhoneNumber(contact_phone, t)
  const errorAddress = validateAddress(contact_address, t)
  const errorHashtags = validateCategoryTags(hashtags, t)
  const errorMajors = validateMajorsOrFieldsOrExperiencesOrDegrees(majors, 'majors', t)
  const errorFields = validateMajorsOrFieldsOrExperiencesOrDegrees(fields, 'fields', t)
  const errorExperiences = validateMajorsOrFieldsOrExperiencesOrDegrees(experiences, 'experiences', t)
  const errorDegrees = validateMajorsOrFieldsOrExperiencesOrDegrees(degrees, 'degrees', t)
  return {
    ...errorPatronSaint,
    ...errorFullname,
    ...errorIdentity,
    ...errorEmail,
    ...errorPhoneNumber,
    ...errorAddress,
    ...errorHashtags,
    ...errorMajors,
    ...errorFields,
    ...errorExperiences,
    ...errorDegrees,
  }
}

export const CreateTeacherModal = ({
  owner_id,
  owner_type,
  initialValues,
  onCancel = NullAsDefault,
  onSubmit = NullAsDefault,
}) => {
  const t = useTranslate()
  const [isToggle, toggle] = useToggle()

  const _initialValues = useMemo(
    () => ({
      owner_id,
      owner_type,
      avatar: undefined,
      identifier_type: 'identitycard',
      gender: 3,
      ...(initialValues ?? {}),
    }),
    [initialValues, owner_id, owner_type]
  )

  return (
    <Formik
      validate={validateCreateAndEditTeacher(t)}
      validateOnMount={true}
      validateOnChange={true}
      enableReinitialize={true}
      initialValues={_initialValues}
      onSubmit={(values) => {
        const {
          owner_id,
          owner_type,
          date_of_birth,
          hashtags = [],
          ...rest
        } = values ?? {}
        onSubmit({
          ...rest,
          hashtags: !!hashtags ? hashtags.join(',') : undefined,
          date_of_birth: !!date_of_birth
            ? getDateString(date_of_birth)
            : undefined,
        })
      }}>
      {({ values }) => {
        const { user, refreshKey } = values ?? {}
        return (
          <ActionModalWrapper
            action={<FormActionBar submitText="create" />}
            className="gap-4">
            <Pure input={[refreshKey]}>
              <div
                key={refreshKey}
                className="flex flex-col gap-6">
                <div className="p-3 border-l-4 border-color-300 rounded-lg shadow">
                  <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                    <FaUserTie
                      size={20}
                      className="mr-2 text-color-500"
                    />
                    {t('teacher information')}
                  </div>
                  <div className="flex flex-col gap-3">
                    <FieldsFactory
                      formSchema={[
                        formSchema.patron_saint__fullname,
                        formSchema.id_validator,
                        formSchema.gender,
                        formSchema.hashtags,
                      ]}
                    />
                  </div>
                </div>

                <div className="p-3 border-l-4 border-blue-600 rounded-lg shadow">
                  <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                    <FaPhone
                      size={18}
                      className="mr-2 text-blue-500"
                    />
                    {t('contact information')}
                  </div>
                  <div className="flex flex-col gap-3">
                    <FieldsFactory
                      formSchema={[
                        formSchema.contact_email__phone,
                        // formSchema.contact_email,
                        // formSchema.contact_phone,
                        formSchema.contact_address,
                      ]}
                    />
                  </div>
                </div>

                <div className="p-3 border-l-4 border-green-500 rounded-lg shadow">
                  <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                    <FaGraduationCap
                      size={18}
                      className="mr-2 text-green-500"
                    />
                    {t('education level')}
                  </div>
                  <div className="flex flex-col gap-3">
                    <FieldsFactory
                      formSchema={[
                        formSchema.majors,
                        formSchema.fields,
                        formSchema.experiences,
                        formSchema.degrees,
                      ]}
                    />
                  </div>
                </div>
              </div>
            </Pure>
          </ActionModalWrapper>
        )
      }}
    </Formik>
  )
}

export const EditTeacherModal = ({
  owner_id,
  owner_type,
  onCancel = NullAsDefault,
  onSubmit = NullAsDefault,
  initialValues = {},
}) => {
  const t = useTranslate()
  const [current, setCurrent] = useState('overview')

  const _initialValues = useMemo(() => {
    const { date_of_birth, avatar, gender, ...rest } = initialValues ?? {}
    return {
      ...rest,
      owner_id,
      owner_type,
      avatar_preview: avatar,
      date_of_birth: parseDayjs(date_of_birth),
    }
  }, [initialValues, owner_id, owner_type])

  return (
    <Formik
      validate={validateCreateAndEditTeacher(t)}
      validateOnMount={true}
      validateOnChange={true}
      enableReinitialize={true}
      initialValues={_initialValues}
      onSubmit={(values) => {
        const changes = shallowDiff(values, _initialValues)
        const {
          owner_id,
          owner_type,
          date_of_birth,
          hashtags = [],
          ...rest
        } = changes ?? {}
        onSubmit(
          _.omitBy(
            {
              ...rest,
              hashtags: !!hashtags ? hashtags.join(',') : undefined,
              date_of_birth: !!date_of_birth
                ? getDateString(date_of_birth)
                : undefined,
            },
            _.isUndefined
          )
        )
      }}>
      <React.Fragment>
        <ForDevelop>
          <ErrorSummaries />
        </ForDevelop>
        <ActionModalWrapper
          tab={current}
          action={<FormActionBar submitText="save" />}
          onTabChange={(key) => {
            setCurrent(key)
          }}
          tabs={[
            {
              key: 'overview',
              label: 'overview',
              component: ({ child }) => (
                <div className="flex flex-col gap-6">{child}</div>
              ),
            },
            {
              key: 'about',
              label: 'about teacher',
              component: () => (
                <FieldsFactory
                  formSchema={[
                    formSchema.majors,
                    formSchema.fields,
                    formSchema.experiences,
                    formSchema.degrees,
                  ]}
                />
              ),
            },
          ]}>
          <div className="p-3 border-l-4 border-color-300 rounded-lg shadow">
            <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
              <FaUserTie
                size={20}
                className="mr-2 text-color-500"
              />
              {t('teacher information')}
            </div>
            <div className="flex flex-col gap-3">
              <FieldsFactory
                formSchema={[
                  formSchema.patron_saint__fullname,
                  formSchema.id_validator,
                  formSchema.date__place_of_birth,
                  formSchema.gender,
                ]}
              />
            </div>
          </div>

          <div className="p-3 border-l-4 border-color-300 rounded-lg shadow">
            <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
              <BsPersonCircle
                size={20}
                className="mr-2 text-color-500"
              />
              {t('image')}
            </div>
            <FieldsFactory formSchema={[formSchema.avatar]} />
          </div>

          <div className="p-3 border-l-4 border-color-300 rounded-lg shadow">
            <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
              <BsHash
                size={22}
                className="mr-2 text-color-500"
              />
              {t('hashtags')}
            </div>
            <FieldsFactory formSchema={[formSchema.hashtags]} />
          </div>

          <div className="p-3 border-l-4 border-blue-600 rounded-lg shadow">
            <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
              <FaPhone
                size={18}
                className="mr-2 text-blue-500"
              />
              {t('contact information')}
            </div>
            <div className="flex flex-col gap-3">
              <FieldsFactory
                formSchema={[
                  formSchema.contact_email__phone,
                  // formSchema.contact_email,
                  // formSchema.contact_phone,
                  formSchema.contact_address,
                ]}
              />
            </div>
          </div>
        </ActionModalWrapper>
      </React.Fragment>
    </Formik>
  )
}
